/** Deploy recovery (WP-08). After a deploy the hashed chunks of the old build are gone: an open
 *  tab that clicks a page it has not loaded yet fails to import it. That is not a bug in the
 *  page — the admin is newer than the tab — so the screen says «Вышла новая версия админки» and
 *  offers a reload, instead of a crash screen that a retry can never fix (it used to loop on
 *  «Что-то сломалось»). Pure helpers plus one module flag; no I/O. */

/** How browsers word a failed dynamic import or a failed CSS preload (Chrome, Firefox, Safari,
 *  Vite's own preload helper). */
const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS|Failed to load module script|ChunkLoadError|Loading chunk [\w-]+ failed/i

export function isChunkLoadError(e: unknown): boolean {
  if (e === null || e === undefined) return false
  const message = e instanceof Error ? `${e.name}: ${e.message}` : String(e)
  return CHUNK_ERROR.test(message)
}

let newVersion = false

/** Vite's `vite:preloadError` fired: the next import error means a new build, whatever the
 *  browser's wording. */
export function markNewVersion(): void {
  newVersion = true
}

export function hasNewVersion(): boolean {
  return newVersion
}

/** For tests and stories only. */
export function resetNewVersion(): void {
  newVersion = false
}

/** A render error that a reload fixes (the tab runs an old build) rather than a crash. */
export function isNewVersionError(e: unknown): boolean {
  return newVersion || isChunkLoadError(e)
}
